import React from "react";

const groups = [
  {
    name: "Cours enfants",
    tag: "5 à 8 ans",
    icon: "🧒",
    accent: "#f5c518",
    soft: "rgba(245,197,24,0.16)",
    slots: [
      { day: "Mardi", time: "17:00 – 18:00" },
      { day: "Jeudi", time: "17:00 – 18:00" },
    ],
  },
  {
    name: "Cours adolescents",
    tag: "9 à 13 ans",
    icon: "🥋",
    accent: "#4ade80",
    soft: "rgba(74,222,128,0.16)",
    slots: [
      { day: "Mercredi", time: "15:30 – 17:00" },
      { day: "Samedi", time: "14:00 – 15:00" },
    ],
  },
  {
    name: "Cours adultes",
    tag: "13 ans et +",
    icon: "⚡",
    accent: "#60a5fa",
    soft: "rgba(96,165,250,0.16)",
    slots: [
      { day: "Mardi", time: "20:00 – 21:30" },
      { day: "Jeudi", time: "20:00 – 21:30" },
      { day: "Samedi", time: "15:00 – 16:30" },
    ],
  },
];

export default function HorairesSection() {
  return (
    <section id="horaires" className="section alt">
      <div className="container">
        <div data-reveal="up">
          <span className="section-label">📅 Planning</span>
          <h2 className="section-title">Horaires</h2>
          <p className="section-sub">Sept séances par semaine, réparties par tranche d'âge.</p>
        </div>

        <div className="sched-grid">
          {groups.map((g, i) => (
            <div
              className="sched-col"
              key={g.name}
              style={{ "--acc": g.accent, "--acc-soft": g.soft }}
              data-reveal="up"
              data-delay={String(i + 1)}
            >
              <div className="sched-head">
                <span className="sched-icon" aria-hidden="true">{g.icon}</span>
                <div>
                  <h3 className="sched-name">{g.name}</h3>
                  <span className="sched-age">{g.tag}</span>
                </div>
              </div>

              <ul className="sched-slots">
                {g.slots.map((s) => (
                  <li className="sched-slot" key={g.name + s.day + s.time}>
                    <span className="slot-day">{s.day}</span>
                    <span className="slot-time">
                      <i className="fa-regular fa-clock" />
                      {s.time}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="sched-venue" data-reveal="up">
          <i className="fa-solid fa-location-dot" />
          <a
            href="https://www.google.com/maps?q=L%C3%A9on%20Autriquestraat%204%2C%201081%20Koekelberg%2C%20Belgi%C3%AB"
            target="_blank"
            rel="noreferrer"
          >
            Centre Sportif Victoria — Rue Léon Autrique 4, 1081 Koekelberg
          </a>
        </div>

        <p className="schedule-note">
          Débutants comme compétiteurs · Cours encadrés par des entraîneurs diplômés Adeps
        </p>
      </div>
    </section>
  );
}
